import { render, staticRenderFns } from "./ui-text.vue?vue&type=template&id=34914acf&scoped=true&"
import script from "./ui-text.vue?vue&type=script&lang=js&"
export * from "./ui-text.vue?vue&type=script&lang=js&"
import style0 from "./ui-text.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34914acf",
  null
  
)

export default component.exports